export default defineNuxtRouteMiddleware((to, from) => {
  const selectedServices = useState('selectedServices', () => ({}));
  const booking = useState('booking');
  const checkout = useState('checkout');
  const destinations = useState('destinations');
  const selectedAccommodationData = useState('selectedAccommodationData');
  const { links, accommodationsData } = useSetup();
  const linksToBeChecked = [links.value.Checkout, links.value.CheckoutDone, links.value.CheckoutUnitList]

  // booking is populated from the query only on first load, so on client-side navigation
  // syncing the selected accommodation/place with the query of the new route
  if (booking.value) {
    const { accommodation_id: accommodationId, place_id: placeId } = to.query;
    if (accommodationId && accommodationsData.value?.[accommodationId] && String(booking.value.accommodation?.id) !== String(accommodationId)) {
      booking.value.accommodation = accommodationsData.value[accommodationId];
      booking.value.accommodation_id = accommodationId;
      delete booking.value.place_id;
      if (selectedAccommodationData.value) selectedAccommodationData.value = accommodationsData.value[accommodationId];
    } else if (!accommodationId && placeId && String(booking.value.accommodation?.id) !== String(placeId)) {
      const place = destinations.value?.places?.find(item => item.id === parseInt(placeId));
      if (place) {
        booking.value.accommodation = place;
        booking.value.place_id = placeId;
        delete booking.value.accommodation_id;
      }
    }
  }
  if(!linksToBeChecked.includes(to.path) && linksToBeChecked.includes(from.path)) {
    selectedServices.value = {}
    if(import.meta.client) sessionStorage.setItem('selectedServices', JSON.stringify(selectedServices.value));
    
    if (booking.value) {
      booking.value.package_external_id = '';
      booking.value.rate_external_id = '';
      booking.value.rate_id = '';
      booking.value.selected_units = [];
      booking.value.selected_rate_name = '';
      booking.value.unit_id = '';
    }

    if (checkout.value?.comments) checkout.value.comments = '';
    
    const _query = { ...to.query }
    for (let item of ['package_external_id', 'rate_external_id', 'rate_id', 'selected_units', 'selected_rate_name', 'unit_id']) {
      if (_query[item]) delete _query[item]
    }
    
    if (JSON.stringify(_query) !== JSON.stringify(to.query)) {
      // Using abortNavigation + navigateTo pattern to avoid infinite loop
      abortNavigation()
      return navigateTo({
        path: to.path,
        query: _query
      })
    }
  }
})